/**
 * Recover the offending alias from a `model-strategy-unknown-alias` error.
 * The orchestrator's message reads:
 *   `language_model_alias "<alias>" is not in the proxy catalog`
 * so we pluck the first quoted segment. Returns `null` when the message
 * doesn't match — a future server copy edit just falls back to the
 * generic toast rather than rendering a confusing extract.
 */
export const extractAliasFromError = (message: string): string | null => {
  const match = message.match(/"([^"]+)"/);
  return match ? match[1] : null;
};
